/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdOpportunities200Ok
 */
export interface GetCharactersCharacterIdOpportunities200Ok {
    /**
     * completed_at string
     * @type {Date}
     * @memberof GetCharactersCharacterIdOpportunities200Ok
     */
    completedAt: Date;
    /**
     * task_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdOpportunities200Ok
     */
    taskId: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdOpportunities200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdOpportunities200Ok(value: object): value is GetCharactersCharacterIdOpportunities200Ok {
    if (!('completedAt' in value) || value['completedAt'] === undefined) return false;
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdOpportunities200OkFromJSON(json: any): GetCharactersCharacterIdOpportunities200Ok {
    return GetCharactersCharacterIdOpportunities200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdOpportunities200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdOpportunities200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'completedAt': (new Date(json['completed_at'])),
        'taskId': json['task_id'],
    };
}

export function GetCharactersCharacterIdOpportunities200OkToJSON(json: any): GetCharactersCharacterIdOpportunities200Ok {
    return GetCharactersCharacterIdOpportunities200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdOpportunities200OkToJSONTyped(value?: GetCharactersCharacterIdOpportunities200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completed_at': ((value['completedAt']).toISOString()),
        'task_id': value['taskId'],
    };
}

